@if (loading()) {
  <xt-portal-app-loader />
}
<router-outlet></router-outlet>
